import { useTranslations } from 'contexts/Translation'
import { Title, Button, TextArea } from '@qonsoll/react-design'
import { MAX_LENGTH_FIELD, MAX_LENGTH_DESCRIPTION, KEYS } from '__constants__'
import { Form, Input } from 'antd'
import PropTypes from 'prop-types'

const RejectReasonSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group } = props

  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting new form instance from Form.useForm hook */
  const [baseForm] = Form.useForm()

  /* Getting used form from props or using base form */
  const usedForm = form || baseForm

  /* Resetting form on cancel */
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  /* Submitting form on enter key press */
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Reject reason status')}
        </Title>
      )}
      <Form.Item
        label={t('Title')}
        name={[...group, 'title']}
        rules={[
          {
            required: true,
            message: t('Please enter reject reason title!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('Reject reason title is too long!')
          }
        ]}>
        <Input placeholder={t('Please enter reject reason title')} />
      </Form.Item>
      <Form.Item
        label={t('Text')}
        name={[...group, 'text']}
        rules={[
          {
            max: MAX_LENGTH_DESCRIPTION,
            message: t('Reject reason text is too long!')
          },
          {
            required: true,
            message: t('Please enter reject reason text!')
          }
        ]}>
        <TextArea placeholder={t('Please enter reject reason text')} />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      onKeyPress={handleKeyPress}
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Reject reason')}
        </Title>
      )}
      <Form.Item
        label={t('Title')}
        name="title"
        rules={[
          {
            required: true,
            message: t('Please enter reject reason title!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('Reject reason title is too long!')
          }
        ]}>
        <Input placeholder={t('Please enter reject reason title')} />
      </Form.Item>
      <Form.Item
        label={t('Text')}
        name={'text'}
        rules={[
          {
            max: MAX_LENGTH_DESCRIPTION,
            message: t('Reject reason text is too long!')
          },
          {
            required: true,
            message: t('Please enter reject reason text!')
          }
        ]}>
        <TextArea placeholder={t('Please enter reject reason text')} />
      </Form.Item>
      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Save')}
          </Button>
        </>
      )}
    </Form>
  )
}

RejectReasonSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array
}

export default RejectReasonSimpleForm
